module.exports = __webpack_public_path__ + "img/xcjgzhqrcode.0e66737e.jpg";